import { AppState } from "../../reducers";
import { PercentagesState } from "./reducer";

export const percentageSelector = (state: AppState): PercentagesState => {
  return state.percentages;
};
